// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"f745730d","661":"09d692b0","787":"4a0456c5","794":"efefb4a4","994":"58d38f46"}[chunkId] + ".chunk.js";
};